"use client";

import { c as _c } from "react/compiler-runtime";
import { motion, AnimatePresence } from "motion/react";
import { useState } from "react";
import SocialLinks from "../molecules/SocialLinks";
export const MobileMenu = () => {
  const $ = _c(24);
  const [isOpen, setIsOpen] = useState(false);
  let t0;
  if ($[0] !== isOpen) {
    t0 = () => setIsOpen(!isOpen);
    $[0] = isOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const toggleMenu = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      x: "100%",
      transition: {
        duration: 0.3,
        ease: "easeInOut"
      }
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      closed: t1,
      open: {
        opacity: 1,
        x: 0,
        transition: {
          duration: 0.3,
          ease: "easeInOut"
        }
      }
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const menuVariants = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      closed: {
        opacity: 0,
        x: 20
      },
      open: _temp
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const menuItemVariants = t3;
  let t4;
  if ($[5] !== isOpen) {
    t4 = <motion.span animate={isOpen ? {
      rotate: 45,
      y: 6
    } : {
      rotate: 0,
      y: 0
    }} className="block h-0.5 w-6 bg-white" />;
    $[5] = isOpen;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== isOpen) {
    t5 = <motion.span animate={isOpen ? {
      opacity: 0
    } : {
      opacity: 1
    }} className="block h-0.5 w-6 bg-white" />;
    $[7] = isOpen;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== isOpen) {
    t6 = <motion.span animate={isOpen ? {
      rotate: -45,
      y: -6
    } : {
      rotate: 0,
      y: 0
    }} className="block h-0.5 w-6 bg-white" />;
    $[9] = isOpen;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== toggleMenu) {
    t7 = <button onClick={toggleMenu} className="flex h-10 w-10 flex-col items-center justify-center space-y-1.5 focus:outline-none" aria-label="Toggle mobile menu">{t4}{t5}{t6}</button>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = toggleMenu;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== isOpen || $[17] !== toggleMenu) {
    t8 = isOpen && <motion.div initial="closed" animate="open" exit="closed" variants={menuVariants} className="fixed inset-0 z-50 flex flex-col bg-slate-900/95 px-6 pt-20 backdrop-blur-md"><button onClick={toggleMenu} className="absolute right-6 top-6 p-2 focus:outline-none" aria-label="Close menu"><svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" /></svg></button><nav className="flex-1"><ul className="flex flex-col space-y-6 text-lg">{["Home", "Portfolio", "FAQs", "Contact"].map((item, i_0) => <motion.li key={item} custom={i_0} variants={menuItemVariants} onClick={toggleMenu}><a href={`/${item.toLowerCase()}`} className="block border-b border-white/10 py-2 transition-colors hover:text-blue-400">{item}</a></motion.li>)}</ul></nav><div className="pb-8"><SocialLinks /></div></motion.div>;
    $[16] = isOpen;
    $[17] = toggleMenu;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t8) {
    t9 = <AnimatePresence>{t8}</AnimatePresence>;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t7 || $[22] !== t9) {
    t10 = <div className="md:hidden">{t7}{t9}</div>;
    $[21] = t7;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  return t10;
};
function _temp(i) {
  return {
    opacity: 1,
    x: 0,
    transition: {
      delay: i * 0.1,
      duration: 0.3
    }
  };
}